export default __webpack_public_path__ + "media/images/features/ja/appeal_right-192473f6edaf6c49e542d14788d9e4f6.png";